import { SalesOrder } from '@rematter/frontend-lib-api-client/grpc/trade/salesOrder_pb';
import { SalesOrderStatus } from '@rematter/frontend-lib-api-client/grpc/trade/salesOrder_pb';
import { Col, FieldDisplay, IDField, StatusTransition } from '@rematter/ui-web';

import { salesOrderStatusLabels } from '../enumLabels';

type SalesOrderStatusTransitionDetailProps = {
  salesOrder?: SalesOrder;
  previousStatus: SalesOrderStatus;
  newStatusLabel: string;
};

export const SalesOrderStatusTransitionDetail = ({
  salesOrder,
  previousStatus,
  newStatusLabel,
}: SalesOrderStatusTransitionDetailProps) => (
  <Col className="@SalesOrderStatusTransitionDetail gap-3" gap3>
    <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
      <span className="text-xs font-medium text-neutral/60">Sales Order</span>
      <div className="grid grid-cols-2 gap-x-4 gap-y-1">
        <IDField label="ID" value={salesOrder?.id?.value} />
        <FieldDisplay
          label="Document Number"
          value={salesOrder?.documentNumber}
        />
      </div>
    </Col>

    <Col className="rounded-md border border-neutral/10 bg-white p-3" gap1>
      <span className="mb-2 text-xs font-medium text-neutral/60">
        Status Change
      </span>
      <StatusTransition
        previousStatus={
          salesOrderStatusLabels[previousStatus] ??
          `Unknown (${previousStatus})`
        }
        newStatus={newStatusLabel}
      />
    </Col>
  </Col>
);
